/*global myModal */

var embedVideo = {
    p: $('.modal'),
    init: function() {
        embedVideo.action();
    },
    action: function() {
        $('.banner-cta').on('click', function() {
            myModal.staticModal('embedVideo', {onlyClose: false, modalDialogClass: 'w-900'});
            setTimeout(function() {
                var videoUrl = embedVideo.p.find('#embed-ad').data('src');
                embedVideo.p.find('#embed-ad').attr('src', videoUrl);
            }, 100);
        });

        embedVideo.p.on('click', '.modal-close', function() {
            embedVideo.p.find('#embed-ad').attr('src', '');
        });
    }
};
